import { SupplierContact } from './supplier-contact';

export interface PurchaseOrderEmailContacts {
  id: string;
  supplierEmailAddress: string;
  supplierCCEmailAddress: string;
  purchaseOrderContactEmailAddress: string;
  supplierContacts: SupplierContact[];
}
